import { render, staticRenderFns } from "./AdminUnactiveModal.vue?vue&type=template&id=22b35fba&"
import script from "./AdminUnactiveModal.vue?vue&type=script&lang=js&"
export * from "./AdminUnactiveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports